<div class="form-container">
  <form #authForm="ngForm" (ngSubmit)="submit(authForm)" novalidate>
    <div>
      <label for="email"> Email</label>
      <input
        type="text"
        id="email"
        [(ngModel)]="form.email"
        name="email"
        #email="ngModel"
        [class.inputerror]="isFormSubmitted && email.invalid"
        required
      />
      <p class="error" *ngIf="isFormSubmitted && email.invalid">
        Required Field.
      </p>
    </div>
    <div>
      <label for="password"> Password</label>
      <input
        type="password"
        id="password"
        [(ngModel)]="form.password"
        #password="ngModel"
        [class.inputerror]="isFormSubmitted && password.invalid"
        name="password"
        required
      />
      <p class="error" *ngIf="isFormSubmitted && password.invalid">
        Required Field.
      </p>
    </div>
    <div [ngStyle]="{ display: isSignup ? 'block' : 'none' }">
      <label for="confirmpassword">Confirm Password</label>
      <input
        type="password"
        id="confirmpassword"
        [(ngModel)]="form.confirmpassword"
        #confirmpassword="ngModel"
        name="confirmpassword"
        [required]="isSignup"
        [class.inputerror]="
          isFormSubmitted && (confirmpassword.invalid || !passNotMatch)
        "
      />
      <p
        class="error"
        *ngIf="isSignup && isFormSubmitted && confirmpassword.invalid"
      >
        Required Field.
      </p>
      <p class="error" *ngIf="isSignup && isFormSubmitted && !passNotMatch">
        Passwords do not match.
      </p>
    </div>
      <div class="btn-container">
      <button
        class="btn-mode"
        type="button"
        (click)="changeMode()"
        [disabled]="loading"
      >
        Switch to {{ isSignup ? "Signin" : "Signup" }}
      </button>
      <button type="submit" class="btn-primary" [disabled]="loading">
        {{
          isSignup
            ? loading
              ? "Signing up.."
              : "Signup"
            : loading
            ? "Signing in.."
            : "Signin"
        }}
      </button>
    </div>
  </form>
</div>
